<div class="soc-dialog">

  <h2 class="soc-title">Sign Off</h2>
  <p class="soc-subtitle">How would you like to sign off today?</p>

  <div class="soc-options">

    <!-- Sign In — Start the Day (reference style) -->
    <button class="soc-card" mat-ripple (click)="onEndDay()">
      <span class="soc-card-icon soc-icon-green">
        <mat-icon>login</mat-icon>
      </span>
      <span class="soc-card-body">
        <span class="soc-card-label">Sign Off — End the Day</span>
        <span class="soc-card-sub">Review tasks &amp; calendar before you leave</span>
      </span>
      <mat-icon class="soc-card-arrow">chevron_right</mat-icon>
    </button>

    <button class="soc-card" mat-ripple (click)="onTemporary()">
      <span class="soc-card-icon soc-icon-orange">
        <mat-icon>logout</mat-icon>
      </span>
      <span class="soc-card-body">
        <span class="soc-card-label">Sign Off — Temporary</span>
        <span class="soc-card-sub">Log out now, resume session later</span>
      </span>
      <mat-icon class="soc-card-arrow">chevron_right</mat-icon>
    </button>

  </div>

  <div class="soc-cancel">
    <button mat-button mat-dialog-close class="soc-cancel-btn">Cancel</button>
  </div>

</div>